import React, { useEffect, useState } from 'react'
import { getCTXNeighborstatus, getCTXNeighborstatusGlobal } from './request/request'
import { useAppSelector } from '../../../../redux/hooks'
import { useAuth } from '../../auth'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import styles from './cloudStatusTable.module.scss'

type Props = {
  className: string
}

type x = {
  Suscription: string
  as: string
  ctxr: string
  ctxr_description: string | null
  neighbor: string
  description: string | null
  state: string
  up: string
  in: number
  out: number
  local_as:number,
  peer_as:number
}

const TablesWidget8: React.FC<Props> = ({ className }) => {
  const Id = useAppSelector((state) => state.SuscriptionSlice.id)
  const nameregion = useAppSelector((state) => state.RegionSlice.name)
  const Type = useAppSelector((state) => state.CloudSlice.Type)
  const tenant = useAppSelector((state) => state.TenantSlice.id)
  const { currentUser } = useAuth()

  const [Loading, setLoading] = useState(false)
  const [statusNeigh, setstatusNeigh] = useState<x[]>([])

  const [searchTerm, setSearchTerm] = useState('')
  const [searchColumn, setSearchColumn] = useState('All')

  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)

  const [sortColumn, setSortColumn] = useState<string>('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc' ? (
        <KeyboardArrowUpIcon className={styles['sort-icon']} />
      ) : (
        <KeyboardArrowDownIcon className={styles['sort-icon']} />
      )
    } else {
      return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />
    }
  }

  function applySearch(data: x[]) {
    if (!searchTerm) return data
    const lowerTerm = searchTerm.toLowerCase()

    return data.filter((d) => {
      if (searchColumn === 'All') {
        return (
          d.ctxr.toLowerCase().includes(lowerTerm) ||
          d.neighbor.toLowerCase().includes(lowerTerm) ||
          d.state.toLowerCase().includes(lowerTerm) ||
          d.up.toLowerCase().includes(lowerTerm) ||
          d.in.toString().includes(lowerTerm) ||
          d.out.toString().includes(lowerTerm) ||
          (d.ctxr_description ?? '').toLowerCase().includes(lowerTerm) ||
          (d.description ?? '').toLowerCase().includes(lowerTerm) ||
          (d.local_as ?? '').toString().includes(lowerTerm) ||
          (d.peer_as  ?? '').toString().includes(lowerTerm) 
        )
      } else {
        let val = ''
        switch (searchColumn) {
          case 'ctxr':
            val = d.ctxr.toLowerCase()
            break
          case 'neighbor':
            val = d.neighbor.toLowerCase()
            break
          case 'state':
            val = d.state.toLowerCase()
            break
          case 'up':
            val = d.up.toLowerCase()
            break
          case 'inOut':
            val = `${d.in}${d.out}`
            break
          case 'as':
            val = `${d.local_as}${d.peer_as}`
            break
          default:
            val = ''
        }
        return val.includes(lowerTerm)
      }
    })
  }

  function applySort(data: x[]) {
    if (!sortColumn) return data
    const sorted = [...data].sort((a, b) => {
      const valA = getValueForSort(a, sortColumn)
      const valB = getValueForSort(b, sortColumn)

      if (typeof valA === 'number' && typeof valB === 'number') {
        return sortDirection === 'asc' ? valA - valB : valB - valA
      } else if (typeof valA === 'string' && typeof valB === 'string') {
        if (valA < valB) return sortDirection === 'asc' ? -1 : 1
        if (valA > valB) return sortDirection === 'asc' ? 1 : -1
        return 0
      }
      return 0
    })
    return sorted
  }

  const getValueForSort = (item: x, column: string): string | number => {
    switch (column) {
      case 'ctxr':
        return item.ctxr.toLowerCase()
      case 'neighbor':
        return item.neighbor.toLowerCase()
      case 'state':
        return item.state.toLowerCase()
      case 'up':
        return item.up.toLowerCase()
      case 'inOut':
        return item.in + item.out
      case 'as':
        return item.local_as + item.peer_as
      default:
        return ''
    }
  }

  const filteredData = applySort(applySearch(statusNeigh))
  const totalItems = filteredData.length
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedData = filteredData.slice(startIndex, endIndex)
  

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  useEffect(() => {
    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    const fetchData = async () => {
      try {
        let response
        if (
          Id !== -1 &&
          Type !== 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatus(Id, signal, Type, nameregion)
        } else if (
          Id !== -1 &&
          Type !== 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatusGlobal(Id, tenant, signal, Type, nameregion)
        } else if (
          Id === -1 &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatus(-1, signal)
        } else if (
          Id === -1 &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatusGlobal(-1, tenant, signal)
        } else if (
          Id !== -1 &&
          Type === 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatus(Id, signal)
        } else if (
          Id !== -1 &&
          Type === 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')
        ) {
          response = await getCTXNeighborstatusGlobal(Id, tenant, signal)
        }

        if (response && !signal.aborted) {
          setstatusNeigh(response.data)
        }
      } catch (error) {
        if (!signal.aborted) {
          // Manejo de error
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false)
        }
      }
    }

    fetchData()

    return () => {
      abortController.abort()
    }
  }, [Id, nameregion, Type, tenant, currentUser])

  return (
    <div className={`card ${className}`}>
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold fs-3 mb-1 f-titulo text-marino">
            BGP Neighbors Status
          </span>
        </h3>
      </div>

      <div className="card-body py-3">
        <div className="tab-content">
          {statusNeigh.length > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
                marginRight: '5px',
              }}
            >
              <div>
                <span className="text-marino f-parrafo fw-semibold">
                  Total Records: {totalItems}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                <div
                  className="input-group custom-search-group"
                  style={{ display: 'flex', height: '30px' }}
                >
                  <span
                    className="input-group-text"
                    style={{
                      justifyContent: 'center',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                    }}
                  >
                    <i
                      className="bi-search"
                      style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                    ></i>
                  </span>
                  <select
                    className="form-select"
                    style={{
                      border: '1px solid var(--bs-gray-300)',
                      width: '135px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem',
                    }}
                    value={searchColumn}
                    onChange={(e) => {
                      setSearchColumn(e.target.value)
                      setCurrentPage(1)
                    }}
                  >
                    <option value="All">All</option>
                    <option value="ctxr">CTX-R</option>
                    <option value="neighbor">Neighbor</option>
                    <option value="state">Status</option>
                    {/* Eliminamos el "up" del select, ya que ya no es una columna independiente */}
                    <option value="inOut">In/Out</option>
                    <option value="as">Local/Peer AS</option>
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      width: '150px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem',
                    }}
                    placeholder={`Search by ${
                      searchColumn === 'All' ? 'All' : searchColumn
                    }`}
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="table-responsive">
            {statusNeigh.length === 0 ? (
              <div className="no-data-message">No Data Available</div>
            ) : (
              <>
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead>
                    <tr className="text-azul">
                      {/* CTX-R / Description */}
                      <th
                        className="table-cell"
                        onClick={() => handleSort('ctxr')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>CTX-R / Description</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('ctxr')}
                          </span>
                        </div>
                      </th>

                      {/* Neighbor / Description */}
                      <th
                        className="table-cell"
                        onClick={() => handleSort('neighbor')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Neighbor / Description</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('neighbor')}
                          </span>
                        </div>
                      </th>

                      {/* Status / Time */}
                      <th
                        className="table-cell"
                        onClick={() => handleSort('state')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Status / Time</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('state')}
                          </span>
                        </div>
                      </th>

                      {/* Prefix Rcv / Snt => in/out */}
                      <th
                        className="table-cell"
                        onClick={() => handleSort('inOut')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Prefix Rcv / Snt</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('inOut')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        onClick={() => handleSort('as')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Local AS/ Peer AS</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('as')}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((d, i) => (
                      <tr key={i} className="table-row">
                        {/* CTX-R + ctxr_description => slash + salto de línea */}
                        <td className="table-cell">
                          <div>
                            <span>{d.ctxr}</span>
                            {d.ctxr_description && (
                              <>
                                {' '} / 
                                <br />
                                <span style={{ color: '#777', fontSize: '0.85em' }}>
                                  {d.ctxr_description}
                                </span>
                              </>
                            )}
                          </div>
                        </td>

                        {/* neighbor + description => slash + salto de línea */}
                        <td className="table-cell">
                          <div>
                            <span>{d.neighbor}</span>
                            {d.description && (
                              <>
                                {' '} / 
                                <br />
                                <span style={{ color: '#777', fontSize: '0.85em' }}>
                                  {d.description}
                                </span>
                              </>
                            )}
                          </div>
                        </td>

                        {/* status => state + up => slash + salto de línea */}
                        <td className="table-cell">
                          <div>
                            <span>{d.state}</span>
                            {d.up && (
                              <>
                                {' '} / 
                                <br />
                                <span style={{ color: '#777', fontSize: '0.85em' }}>
                                  {d.up}
                                </span>
                              </>
                            )}
                          </div>
                        </td>

                        {/* Prefix Rcv/Snt => in / out */}
                        <td className="table-cell">
                          {d.in} / {d.out}
                        </td>
                        {/* Local AS / Peer AS => in / out */}
                        <td className="table-cell">
                          {d.local_as} / {d.peer_as}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {filteredData.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      {currentPage > 1 && (
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Previous
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      {currentPage < totalPages && (
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Next
                        </button>
                      )}
                      <div className={`select-container ${styles.selectContainer}`}>
                        <select
                          className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                          aria-label="Select items per page"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value))
                            setCurrentPage(1)
                          }}
                        >
                          <option value={5}>5 rows</option>
                          <option value={10}>10 rows</option>
                          <option value={20}>20 rows</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export { TablesWidget8 }
